import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/courseItemCategory/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/courseItemCategory/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  // console.log('createItem', data)

  return request({
    url: '/courseItemCategory/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  // console.log('updateItem', data)

  return request({
    url: '/courseItemCategory/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/courseItemCategory/Delete',
    method: 'delete',
    data,
  })
}

export function fetchAll() {
  return request({
    url: '/courseItemCategory/List',
    method: 'post',
    data: {
      page: 0,
      limit: 0,
    },
  })
}
